import { getToggles } from 'quick-quote/feature-toggles'
import fnaNavButtons from './fna/nav-buttons'
import { ROUTE_PATH } from '../../constants/path'

import oldQuickQuoteNavButtons from './old-quick-quote/nav-buttons'
import quickQuoteV1NavButtons from './quick-quote/nav-buttons'
import quickQuoteV2NavButtons from './quick-quote/v2/nav-buttons'

const optyNavigationButton = () => {
  return [
    {
      path: ROUTE_PATH.OPTY,
      props: {
        backButton: {
          type: 'link',
          toHome: true,
        },
      },
    },
  ]
}

const mwpNavigationButton = () => {
  return [
    {
      path: ROUTE_PATH.MW_PLUS,
      props: {
        backButton: {
          type: 'link',
          toHome: true,
        },
      },
    },
  ]
}

export default (state) =>
  // quickQuoteV2NavButtons(state)
  oldQuickQuoteNavButtons(state)
    .concat(fnaNavButtons(state))
    .concat(getToggles().ENABLE_FNA_QQ_NAV_V2 ? quickQuoteV2NavButtons(state) : quickQuoteV1NavButtons(state))
    .concat(optyNavigationButton())
    .concat(mwpNavigationButton())
